import React from "react";
import FlexView from "react-flexview/lib";
import {
  FirebaseService,
  FirebaseConfigKey,
} from "../../../../services/FirebaseService";
import { KPretty } from "../../../../services/utils";
import { isMobile } from "react-device-detect";
import { PersonalInjuryPopover } from "../../../Core/Popover/PersonalInjuryPopover";
import { ReactComponent as DiscountIcon } from "../../../../assets/discount-icon.svg";

var classNames = require("classnames");

interface AdditionalCoveragesProps {
  personalInjuryLimitPremium: Number;
  personalInjuryLimit: Number;
  medicalExpenseLimitPremium: Number;
  medicalExpenseLimit: Number;
  discountMultiplier: number;
}

export const AdditionalCoverages = ({
  personalInjuryLimitPremium,
  personalInjuryLimit,
  medicalExpenseLimitPremium,
  medicalExpenseLimit,
  discountMultiplier,
}: AdditionalCoveragesProps) => {
  return (
    <FlexView column={true}>
      <FlexView marginTop={15} className="space-between margin-bottom-basic ">
        <div className="text-body bold black">
          Additional Coverages <PersonalInjuryPopover />
        </div>
      </FlexView>
      {discountMultiplier != 0 && (
        <FlexView
          column={true}
          className={classNames(
            { "space-between": !isMobile },
            "margin-bottom-small"
          )}
        >
          <div
            style={{ paddingLeft: "30px" }}
            className="text-small black line margin-top-small full-width space-between"
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className="margin-right-3 line"
            >
              <DiscountIcon className="powderblue small-icon" />{" "}
              <span style={{ color: "#009369", paddingLeft: "10px" }}>
                Courses & Memberships Discount Applied
              </span>
            </div>
          </div>
        </FlexView>
      )}
      {personalInjuryLimitPremium > 0 && (
        <FlexView
          column={true}
          className={classNames(
            { "space-between": !isMobile },
            "margin-bottom-small"
          )}
        >
          <div className="black text-small">
            {KPretty(personalInjuryLimit)} Personal Injury Coverage (Including
            Privacy)
          </div>
          <div className="gray margin-top-small text-tiny">
            Premium:{" "}
            {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
            {personalInjuryLimitPremium.toLocaleStringToFixed()}
          </div>
        </FlexView>
      )}
      {medicalExpenseLimitPremium > 0 && (
        <FlexView
          column={true}
          className={classNames({ "space-between": !isMobile })}
        >
          <div className="black text-small">
            {KPretty(medicalExpenseLimit)} Medical Expenses
          </div>
          <div className="gray margin-top-small text-tiny">
            Premium:{" "}
            {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
            {medicalExpenseLimitPremium.toLocaleStringToFixed()}
          </div>
        </FlexView>
      )}
    </FlexView>
  );
};
